// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar-background-md {
  background-color: #BE1E2D;
}

.toolbar-background-ios {
  background-color: #BE1E2D;
}

.toolbar-title {
  font-size: 16px;
  color: white;
}

.scroll-content {
  overflow: hidden;
  background-color: white;
}

.footer {
  padding: 6px 15px 10px 20px;
  background: white;
}

.show-page .modal-wrapper {
  height: 280px !important;
}

input {
  border: 1px solid #E0E0E0;
  border-radius: 4px;
  height: 36px;
}

.copy-link {
  height: 50px;
  background-color: lightgreen;
  font-size: 18px;
  text-align: center;
  opacity: 0.9;
  border-radius: 30px;
  top: 45px;
  position: relative;
}

.copied-link {
  position: relative;
  top: 14px;
}

.share-copy-url {
  width: 100% !important;
  position: fixed;
  min-height: 300px !important;
  background: white;
  height: 350px;
}

button.parent-buy-btn.button.button-md.button-default.button-default-md:hover {
  opacity: 0.7 !important;
}

.modal-wrapper {
  background-color: #ffffff;
  height: 20%;
}

.modal {
  background-color: white;
  border-radius: 3px;
}

.header {
  color: red;
  border-bottom: 1px solid #eaeaea;
}

.header p {
  margin: 0px;
}

.close-btn {
  float: right;
  --background: transparent;
  color: white;
  font-size: 17px;
  width: 40px;
  height: 30px;
}

.row label {
  float: right;
  padding-right: 15px;
  font-size: 13px;
  font-weight: bold;
}

.row input, textarea {
  padding: 6px 12px;
  font-size: 14px;
  color: #555;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  width: 50%;
}

.modal-wrapper {
  height: 30%;
}
.modal-wrapper .scroll-content {
  overflow: hidden;
}

.stripe-modal .modal-wrapper {
  box-shadow: 0 28px 48px rgba(0, 0, 0, 0);
  height: 250px;
}
.stripe-modal .modal-wrapper .scroll-content {
  overflow: hidden;
}

.close-btn {
  border-radius: 5%;
  font-size: 15px;
  white-space: pre-line;
  margin: 3px !important;
  width: 48%;
  background-color: #BE1E2D !important;
  text-decoration: none;
  color: #fff;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.tool-bar {
  background: #BE1E2D;
  --background: #BE1E2D;
  border-bottom: 2px solid #EAEAEA;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/share-copy-url/share-copy-url.page.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,eAAA;EACA,YAAA;AACJ;;AACA;EACI,gBAAA;EACA,uBAAA;AAEJ;;AAAA;EACI,2BAAA;EACA,iBAAA;AAGJ;;AAAI;EACI,wBAAA;AAGR;;AACA;EACI,yBAAA;EACA,kBAAA;EACA,YAAA;AAEJ;;AACA;EACI,YAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAEJ;;AACA;EACI,kBAAA;EACA,SAAA;AAEJ;;AACA;EACI,sBAAA;EACA,eAAA;EACA,4BAAA;EACA,iBAAA;EACA,aAAA;AAEJ;;AACA;EACI,uBAAA;AAEJ;;AACA;EACI,yBAAA;EACA,WAAA;AAEJ;;AACA;EACI,uBAAA;EACA,kBAAA;AAEJ;;AACA;EACI,UAAA;EACA,gCAAA;AAEJ;;AACA;EACI,WAAA;AAEJ;;AACA;EACI,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAEJ;;AACA;EACI,YAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAEJ;;AACA;EACI,iBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AAEJ;;AACA;EACI,WAAA;AAEJ;AAAI;EACI,gBAAA;AAER;;AAEA;EACI,wCAAA;EACA,aAAA;AACJ;AAAI;EACI,gBAAA;AAER;;AAEA;EACI,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,UAAA;EACA,oCAAA;EACA,qBAAA;EACA,WAAA;EACA,+GAAA;AACJ;;AAEA;EACI,mBAAA;EACA,qBAAA;EACA,gCAAA;EACA,YAAA;AACJ","sourcesContent":[".toolbar-background-md{\n    background-color: #BE1E2D;\n}\n\n.toolbar-background-ios{\n    background-color: #BE1E2D;\n}\n\n.toolbar-title {\n    font-size: 16px;\n    color: white;\n}\n.scroll-content{\n    overflow: hidden;\n    background-color:white;\n}\n.footer{\n    padding: 6px 15px 10px 20px;\n    background: white;\n}\n.show-page{\n    .modal-wrapper{\n        height: 280px !important;\n    }\n}\n\ninput{\n    border: 1px solid #E0E0E0;\n    border-radius: 4px;\n    height: 36px;\n}\n\n.copy-link{\n    height: 50px;\n    background-color: lightgreen;\n    font-size: 18px;\n    text-align: center;\n    opacity: 0.9;\n    border-radius: 30px;\n    top: 45px;\n    position: relative;\n}\n\n.copied-link{        \n    position: relative;\n    top: 14px;\n}\n\n.share-copy-url {\n    width: 100% !important;\n    position: fixed;\n    min-height: 300px !important;\n    background: white;\n    height: 350px;\n}\n\nbutton.parent-buy-btn.button.button-md.button-default.button-default-md:hover {\n    opacity: 0.7 !important;\n}\n\n.modal-wrapper {\n    background-color: #ffffff;\n    height: 20%;\n}\n\n.modal {\n    background-color: white;\n    border-radius: 3px;\n}\n\n.header {\n    color: red;\n    border-bottom: 1px solid #eaeaea;\n}\n\n.header p {\n    margin: 0px;\n}\n\n.close-btn {\n    float: right;\n    --background: transparent;\n    color: white;\n    font-size: 17px;\n    width: 40px;\n    height: 30px;\n}\n\n.row label {\n    float: right;\n    padding-right: 15px;\n    font-size: 13px;\n    font-weight: bold;\n}\n\n.row input, textarea {\n    padding: 6px 12px;\n    font-size: 14px;\n    color: #555;\n    background-color: #fff;\n    border: 1px solid #e0e0e0;\n    border-radius: 4px;\n    width: 50%;\n}\n\n.modal-wrapper {\n    height: 30%;\n\n    .scroll-content {\n        overflow: hidden;\n    }\n}\n\n.stripe-modal .modal-wrapper {\n    box-shadow: 0 28px 48px rgba(0, 0, 0, 0);\n    height: 250px;\n    .scroll-content {\n        overflow: hidden;\n    }\n}\n\n.close-btn {\n    border-radius: 5%;\n    font-size: 15px;\n    white-space: pre-line;\n    margin: 3px !important;\n    width: 48%;\n    background-color:#BE1E2D !important;   \n    text-decoration:none;\n    color:#fff;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n}\n\n.tool-bar {\n    background: #BE1E2D;\n    --background: #BE1E2D;\n    border-bottom: 2px solid #EAEAEA;\n    color:white;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
